import { render, staticRenderFns } from "./legalInfo.vue?vue&type=template&id=10d3376c"
import script from "./legalInfo.vue?vue&type=script&lang=js"
export * from "./legalInfo.vue?vue&type=script&lang=js"
import style0 from "./legalInfo.vue?vue&type=style&index=0&id=10d3376c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports